// extracted by mini-css-extract-plugin
module.exports = {"container":"CallLayout_container__2kH8K","minimized":"CallLayout_minimized__zkcWZ","videoContainer":"CallLayout_videoContainer__2CwwB","spin360":"CallLayout_spin360__2PlOR"};